import {
  SingleResponse,
  UrlPathBuilder,
  type AdminTwLogin,
} from "@tastyworks/tastyworks-api"

export const launchAccountBasedOnRegulatoryDomain = (
  accountNumber: string,
  sessionToken: string
) => {
  launchDesktopApplication(getDesktopUrl(), accountNumber, sessionToken)
}

export const getWebBasedTwoUrl = () =>
  sessionStorage.getItem("isUserUsaRegulatoryDomain") === "true"
    ? import.meta.env.VITE_TT_WEB_BASE_URL
    : import.meta.env.VITE_IG_WEB_BASE_URL

export const getDesktopUrl = () =>
  sessionStorage.getItem("isUserUsaRegulatoryDomain") === "true"
    ? import.meta.env.VITE_TT_DESKTOP_PROTOCOL
    : import.meta.env.VITE_IG_DESKTOP_PROTOCOL

export const getElectronUrl = () => import.meta.env.VITE_TT_ELECTRON_PROTOCOL

export const initializeRegulatoryDomain = (
  response: SingleResponse<AdminTwLogin>
): void => {
  sessionStorage.setItem(
    "regulatoryDomains",
    response.data?.regulatoryDomain.join(",") ?? ""
  )
  sessionStorage.setItem(
    "isUserUsaRegulatoryDomain",
    (response.data?.regulatoryDomain.includes("USA") ?? false).toString()
  )
}

export const launchWebTwoPointOh = (
  env: string,
  accountNumber: string,
  sessionToken: string
) => {
  window.open(
    new UrlPathBuilder(env).toUrl("", {
      "tastyworks-account": accountNumber,
      "tastyworks-token": sessionToken,
    }),
    "_blank"
  )
}

export const launchDesktopApplication = (
  env: string,
  accountNumber: string,
  sessionToken: string
) => {
  window.open(
    `${env}?tastyworksAccount=${accountNumber}&tastyworksToken=${encodeURIComponent(
      sessionToken
    )}`,
    "_blank"
  )
}

export const launchElectronApp = (
  env: string,
  accountNumber: string,
  sessionToken: string
) => {
  window.open(
    `${env}?tastyworks-account=${accountNumber}&tastyworks-token=${encodeURIComponent(
      sessionToken
    )}`,
    "_blank"
  )
}

export const APEX_CLEARING_BASE_URL =
  "https://public-apps.apexclearing.com/accounts/#"

export const launchApexClearing = (accountNumber: string) => {
  window.open(`${APEX_CLEARING_BASE_URL}/${accountNumber}`, "_blank")
}
